// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import echarts from 'echarts'
/* import format from './components/format.js' */
import 'element-ui/lib/theme-chalk/index.css' 
import './icomoon/style.css'
import './icomoon/reset.css'
import './icomoon/zdyicon/iconfont.css' 
import './icomoon/zdyicon/iconfont' 

Vue.config.productionTip = false

/* Vue.prototype.format=format */
Vue.use(ElementUI);
//Vue.use(echarts);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
}) 



// WEBPACK FOOTER //
// ./src/main.js